import {
    AUSTRALIA,
    AUSTRIA,
    BELGIUM,
    BULGARIA,
    CHINA,
    CZECH_REPUBLIC,
    DENMARK,
    ESTONIA,
    FRANCE,
    GERMANY,
    GREECE,
    HUNGARY,
    ISRAEL,
    ITALY,
    JAPAN,
    LITHUANIA,
    NETHERLANDS,
    NEW_ZEALAND,
    NORWAY,
    POLAND,
    PORTUGAL,
    SLOVAKIA,
    SPAIN,
    SWEDEN,
    UNITED_KINGDOM,
    UNITED_STATES,
} from 'mk/autogenerated/translations/constants.04d3e1f00b7cb297e68e715a059513d7'

export const COUNTRY_MESSAGES = {
    AUSTRALIA,
    AUSTRIA,
    BELGIUM,
    BULGARIA,
    CHINA,
    CZECH_REPUBLIC,
    DENMARK,
    ESTONIA,
    FRANCE,
    GERMANY,
    GREECE,
    HUNGARY,
    ISRAEL,
    ITALY,
    JAPAN,
    LITHUANIA,
    NETHERLANDS,
    NEW_ZEALAND,
    NORWAY,
    POLAND,
    PORTUGAL,
    SLOVAKIA,
    SPAIN,
    SWEDEN,
    UNITED_KINGDOM,
    UNITED_STATES,
};
